/**
 * Created by lu on 2018/5/15.
 * 下拉消息框
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('../dropdown/Dropdown'),
    slot: {
        btn: ['html', {
            'class': ['notice-count', nb.bind('hasMsg')],
            $html: [{
                tag: 'i',
                'class': 'iconfont icon-lingdang'
            }, {
                tag: 'span',
                'class': '',
                $text: nb.bind('MsgText')
            }, {
                tag: 'span',
                'class': 'count',
                // $text:'(2)'
                $text: nb.bind('countText')
            }]
        }],
        content: ['html', {
            'class': ['msg-dropdown', nb.bind('hasMsg'), nb.bind('inState')],
            $html: [{
                'class': 'msg-box',
                $html: [{
                    'class': 'dropdown-title',
                    $text: nb.bind('NewMsgText')
                }, {
                    $name: 'msgList',
                    $type: require('./MsgList'),
                    $model: 'msgList'
                }, {
                    $name: 'see-all',
                    'class': 'see-all',
                    $text: nb.bind('AllMsgText')
                }]
            }]
        }]
    },
    method: {
        init: function () {
            var self = this;
            this.$('see-all').on('click', function () {   //点击查看全部
                window.location.href = 'msgList.html';
            });
            this.$('msgList').$().on('click', '.msg-item', function () { //todo 点击某一个
                window.location.href = 'msgList.html';
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/notice/MsgWrap.js
// module id = 39
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30